<template lang="pug">
v-container.pa-0.pt-2
  crud-scroll-details(
    ref="list"
    v-if="agreementsFiltered.length"
    :detailsComponent="detailsComponent"
    :adapter="adapter"
    :filters="filters"
    :query="query"
    :queryField="{ label: 'Номер договора', key: 'search[number]' }"
  )
    template(#list-header-bottom="{ init, unSelect, resetSearch }")
      v-chip-group.ml-2(
        v-model="selected"
        mandatory
      )
        v-chip(filter small color="secondary") все
        v-chip(filter color="secondary" small) требуют подписания

    template(#list-item="{ item }")
      v-list-item-action.mr-4
        v-badge(
          dot overlap
          :value="item.chat ? item.chat.exists_unread_messages : false"
          color="error"
          offset-x="18"
          offset-y="18"
        )
          v-icon(
            size="28"
          ) {{ item.users.length > 1 ? 'mdi-account-multiple' : 'mdi-account' }}
      v-list-item-content.mr-4
        v-list-item-title.text-body-2: strong {{ item.number }}
        v-list-item-subtitle.caption {{ item.owner.full_name }}

            //- v-chip(
            //-   v-if="item.needToSign"
            //-   color="warning" outlined small
            //- )
            //-   v-icon(left small) mdi-alert
            //-   | требуется подпись
      v-alert.mb-0(
        dense text
        :color="item.isPaymentPrePayment && item.is_active ? 'success' : 'error'"
      )
        .text-h6 {{ item.is_active ? `${item.paymentPercent} %` : 'Не активен' }}
  v-alert(v-else type="info") Нет ни одного типового договора
</template>

<script>
import CrudScrollDetails from '@/components/Global/crudScrollDetails/index.vue';
import SelectCourse from '@/components/InputFields/course/SelectCourse.vue';
import PeriodInput from '@/components/InputFields/PeriodInput.vue';
import ListDetail from '../components/ListDetail.vue';

export default {
  components: {
    CrudScrollDetails,
  },
  props: {
    agreements: { type: Object, required: true },
  },
  data() {
    return {
      selected: 0,
      detailsComponent: {
        component: ListDetail,
        component_listeners: {
          update: (id) => {
            this.selectById(id);
          },
          unSelect: () => { this.$refs.list.unSelect(); this.$refs.list.refreshList(); },
        },
      },
    };
  },
  computed: {
    filters() {
      const defaultAttrs = {
        filled: true, solo: true, flat: true,
      };
      return [
        {
          key: 'search[owner_full_name]',
          component: 'v-text-field',
          component_attrs: {
            ...defaultAttrs,
            label: 'Заказчик',
          },
        },
        {
          key: 'search[prior_record_code]',
          component: 'v-text-field',
          component_attrs: {
            ...defaultAttrs,
            label: 'Код набора',
          },
        },
        {
          key: 'search[course_id]',
          component: SelectCourse,
          component_attrs: {
            ...defaultAttrs,
            service: this.$conf.COURSE_SERVICE.organization,
            itemValue: 'id',
            label: 'Курс',
            chips: true,
          },
        },
        {
          key: 'period',
          component: PeriodInput,
          component_attrs: {
            class: 'mt-4',
            type: 'only-date',
            label: 'Даты набора',
          },
        },
      ];
    },
    query() {
      const results = {
        ...this.selected ? { 'search[has_count_signature]': 1 } : {},
        ...this.$route.query.id ? {} : { 'search[is_active]': true },
      };
      return results;
    },
    agreementsFiltered() {
      return Object.values(this.agreements).filter((i) => !!i.id);
    },
  },
  watch: {
    agreementsFiltered: {
      handler(val) {
        if (val.length) {
          this.$nextTick(() => {
            if (this.$route.query.id) {
              this.selectById(this.$route.query.id);
              this.$router.replace({ query: { } });
            }
          });
        }
      },
      immediate: true,
    },
  },

  methods: {
    selectById(id) {
      this.$refs.list.selectById(id);
    },
    adapter(params) {
      const ids = this.agreementsFiltered.map((i) => i.id);
      const extendParams = {
        ...params,
        ...params.period ? {
          'search[prior_record_date][start_at]': params.period.start,
          'search[prior_record_date][end_at]': params.period.end,
        } : {},
        'search[number]': params['search[number]'] ? params['search[number]'] : null,
      };
      return this.$api.contracts.getContractsModel({
        expand: 'organization,is_signed_customer_act,is_signed_executor_act,users,transactions,typical_contract_discount,typical_contract,document,is_signed_executor,is_signed_customer,owner,act',
        'search[typical_contract_id]': ids,

        sort: 'created_at',
        ...extendParams,
      });
    },
  },
};
</script>
